interface EmployeeReviewProp {
  data: any;
}

const KraEmpReviewDetailsSection: React.FC<EmployeeReviewProp> = ({ data }) => {
  const {
    srNo,
    employeeId,
    employee,
    competencyName,
    goal,
    category,
    categoryDescription,
    smartGoal,
    target,
    targetAchievementDate,
    attachment,
    status,
    action,
  } = data;

  return (
    <div className="py-5 px-4 mx-1">
      <div className="row row-gap-2 fs-16">
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Employee Name</div>
          <div className="col-6 col-md-8">{employee}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Behavioural Competency</div>
          <div className="col-6 col-md-8">{competencyName}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Category</div>
          <div className="col-6 col-md-8">{category}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Category Description</div>
          <div className="col-6 col-md-8">{categoryDescription}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Status</div>
          <div className="col-6 col-md-8">{status}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Goal</div>
          <div className="col-6 col-md-8">{goal}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Smart Goal</div>
          <div className="col-6 col-md-8">{smartGoal}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">Target</div>
          <div className="col-6 col-md-8">{target}</div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 fw-medium">
            Target Achievement Date
          </div>
          <div className="col-6 col-md-8">{targetAchievementDate}</div>
        </div>
        {/* <div className="row">
                    <div className="col-6 col-md-4 fw-medium">Goal</div>
                    <div className="col-6 col-md-8">{ }</div>
                </div> */}
      </div>
    </div>
  );
};

export default KraEmpReviewDetailsSection;
